module.exports = __webpack_public_path__ + "media/images/diy/star-3ca0aa93ae59a4478635b589f8925d6e.svg";